import { cn } from '@/lib/utils'

/** How a field in the review looks: red while it is empty-and-needed, or wrong. */
export const inputClass = (empty: boolean, required?: boolean, invalid?: boolean) =>
    cn(
        'w-full rounded-md border bg-white px-2.5 py-1.5 text-sm outline-none transition-colors placeholder:text-muted-foreground focus:border-gray-500 disabled:cursor-not-allowed disabled:opacity-60',
        invalid || (empty && required) ? 'border-red-300' : 'border-gray-200',
    )
